<div class="container">
  <div class="text-small">{{ title }}</div>
  <div class="status-container">
    @for (status of userStatus; track status) {
      <ht-checkbox
        role="checkbox-status"
        [(ngModel)]="status.checked"
        (change)="onCheckStatusChange()"
      >
        <div [ngClass]="status.color" class="text-body-small">{{
          statusLabel(status)
        }}</div>
      </ht-checkbox>
    }
  </div>
</div>
